import React, { useId } from "react";
import PropTypes from "prop-types";

const paths = [
  "M4.67582 14.6493C7.85901 12.7836 11.891 12.7836 15.0742 14.6493C15.175 14.7084 15.3005 14.7781 15.4434 14.8574C16.076 15.2086 17.0479 15.7481 17.7133 16.3892C18.1288 16.7896 18.5384 17.3303 18.6131 18.0037C18.6932 18.7252 18.3709 19.3911 17.7546 19.9691C16.7045 20.9539 15.4366 21.75 13.7942 21.75H5.95578C4.31344 21.75 3.04552 20.9538 1.99544 19.9691C1.37912 19.3911 1.05677 18.7252 1.13689 18.0037C1.21166 17.3303 1.62122 16.7896 2.0367 16.3892C2.70209 15.7481 3.674 15.2086 4.30665 14.8574C4.44946 14.7781 4.57501 14.7084 4.67582 14.6493Z",
  "M5.12501 7C5.12501 4.37665 7.25166 2.25 9.87501 2.25C12.4984 2.25 14.625 4.37665 14.625 7C14.625 9.62335 12.4984 11.75 9.87501 11.75C7.25166 11.75 5.12501 9.62335 5.12501 7Z",
  "M19.3751 3C19.9274 3 20.3751 3.44772 20.3751 4V5.5H21.8751C22.4274 5.5 22.8751 5.94772 22.8751 6.5C22.8751 7.05228 22.4274 7.5 21.8751 7.5H20.3751V9C20.3751 9.55228 19.9274 10 19.3751 10C18.8228 10 18.3751 9.55228 18.3751 9V7.5H16.8751C16.3228 7.5 15.8751 7.05228 15.8751 6.5C15.8751 5.94771 16.3228 5.5 16.8751 5.5L18.3751 5.5V4C18.3751 3.44772 18.8228 3 19.3751 3Z",
];

const gradients = [
  { x1: "17.4136", y1: "6.25444", x2: "2.44969", y2: "20.0885" },
  { x1: "17.4136", y1: "6.25444", x2: "2.44969", y2: "20.0885" },
  { x1: "22.3905", y1: "4.43749", x2: "17.0046", y2: "9.9856" },
];

const RequestsIcon = ({ selected, width, height, className, ...props }) => {
  const id = useId().replace(/:/g, "");
  const isActive = selected;
  const clipId = `requests-clip-${id}`;
  const gradientIds = paths.map((_, index) => `requests-gradient-${index}-${id}`);

  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <g clipPath={`url(#${clipId})`}>
        <g opacity={isActive ? undefined : "0.5"}>
          {paths.map((path, index) => (
            <path key={path} fillRule={index === 2 ? "evenodd" : undefined} clipRule={index === 2 ? "evenodd" : undefined} d={path} fill={`url(#${gradientIds[index]})`} />
          ))}
        </g>
      </g>
      <defs>
        {gradientIds.map((gradientId, index) => (
          <linearGradient key={gradientId} id={gradientId} {...gradients[index]} gradientUnits="userSpaceOnUse">
            <stop stopColor="#D946EF" />
            <stop offset="1" stopColor="#67E8F9" />
          </linearGradient>
        ))}
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

RequestsIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

RequestsIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default RequestsIcon;
